export const API = {
  locations: {
    path: '/locations',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  location: {
    path: '/locations/{{id}}',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  create: {
    path: '/locations',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
        area: body?.area?.id,
        location: body?.location?.toUpperCase(),
        marina: body?.marina?.toUpperCase(),
        code: body?.code,
      },
    }),
  },
  update: {
    path: '/locations/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
        area: body?.area?.id ? body?.area?.id : null,
        location: body?.location?.toUpperCase(),
        marina: body?.marina?.toUpperCase(),
        code: body?.code,
      },
    }),
  },
  delete: {
    path: '/locations/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },
  select: {
    path: '/locations?pagination[page]=1&pagination[pageSize]=1000',
    method: 'GET',
    get: 'data',
    auth: true,
    fallback: [],
    transform: (data) =>
      data.map((item) => ({
        name: `${item.attributes.code ? `- ${item.attributes.code}` : ''} - ${
          item.attributes.location
        } ${item.attributes.marina ? `- ${item.attributes.marina}` : ''}`,
        id: item.id,
      })),
  },
};
